import { render, staticRenderFns } from "./PreferencesStdObForm.vue?vue&type=template&id=b2563712&"
import script from "./PreferencesStdObForm.vue?vue&type=script&lang=js&"
export * from "./PreferencesStdObForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports